import WarningIcon from "@material-ui/icons/Warning";
import RiskLevelList from "./RiskLevelList";

export default {
  list: RiskLevelList,
  icon: WarningIcon,
};
